// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CEOdV","title":"styles_title__AYWEB","marqueeContainer":"styles_marqueeContainer__Y0wKT","brandImage":"styles_brandImage__sdZ5A"};